import {
    FetchState,
    CustomerFormDocumentState,
    CustomerFormDocumentResponse
} from "@/shared/types";
import * as bankService from "@/shared/api/bankService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const initialState: CustomerFormDocumentState = {
    fetchState: FetchState.Uninitialized,
    availablePlanTypes: [],
    formDocuments: []
};

export const useCustomerFormDocumentsStore = defineStore("customerFormDocuments", {
    state: (): CustomerFormDocumentState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setResponse (response: CustomerFormDocumentResponse) {
            this.formDocuments = response.formDocuments;
            this.availablePlanTypes = response.availablePlanTypes;
        },
        loadDocuments (): Promise<any> {
            this.setFetchState(FetchState.Loading);
            return bankService.getCustomerFormDocuments().then(response => {
                this.setResponse(response.data);
                this.setFetchState(FetchState.Loaded);
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: false });
            });
        }
    }
});
